export function Brand({ subtitle, className }: { subtitle?: string; className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className ?? ""}`}>
      <img src="/assets/logo.png" alt="Sunday State" className="h-11 w-auto" />
      <div className="flex items-center gap-3">
        <span className="text-xl font-semibold text-teal-dark tracking-tight">HQ</span>
        {subtitle && (
          <>
            <span className="h-6 w-px bg-line" />
            <span className="text-sm text-gray2">{subtitle}</span>
          </>
        )}
      </div>
    </div>
  );
}
